<template>
    <v-content>
        <v-row  class="mb-6" justify="center" no-gutters ><span class="title pt-4">Admin Control Panel</span></v-row>
        <v-row class="mb-6" no-gutters>
            <v-col :md=2>
                <v-treeview
                    activatable
                    color="primary"
                    :items="menu_items"
                    class="menu_items"
                >
                    <template slot="label" slot-scope="{ item }">
                        <a v-if="item.to" @click="goToView(item)">{{ item.name }}</a>
                        <span v-else>{{ item.name }}</span>
                    </template>
                </v-treeview>                
            </v-col>
            <v-col :md=10>
                <UserAdmin v-if="pageView=='userAdmin'" :filterStatus="filter"/>
                <AuditAdmin v-if="pageView=='auditAdmin'" :filterStatus="filter"/>
            </v-col>
        </v-row>
    </v-content>    
</template>
<script>
import Users from '@/api/users'
import UserAdmin from '@/modules/admin/components/UserAdmin'
import AuditAdmin from '@/modules/admin/components/AuditAdmin'
export default {
    components:{
        UserAdmin,
        AuditAdmin
    },
    data: () => ({
        pageView:"",
        filter:"active",
        menu_items: [
            {
                id: 1,
                name: 'Audits',
                children: [
                    { id: 2, name: 'Logins', to: 'auditAdmin', filter:'user_audit'},
                    { id: 3, name: 'Documents', to: 'auditAdmin', filter:'document_audit'},
                ],
            },
            {
                id: 10,
                name: 'Users',
                children: [
                    { id: 11, name: 'Requested users', to: 'userAdmin', filter:'request' },
                    { id: 12, name: 'Confirmed users', to: 'userAdmin', filter:'confirmed'},
                    { id: 13, name: 'Active users', to: 'userAdmin', filter:'active'},
                    { id: 14, name: 'Disabled users', to: 'userAdmin', filter:'disable'},
                ],
            },
        ]
    }),
    methods: {
        goToView(item){
            this.pageView=item.to
            this.filter=item.filter
        }
    }
}
</script>
<style scoped>
    .menu_items{
        font-size: smaller !important ;
    }
    .title{
        font-size: medium !important;
        color: #003498 !important;
    }
</style>